import axios from 'axios';
import { useEffect, useState } from 'react';
import { RequestStatus } from 'react-app-env';

export const useProxyHealth = () => {
  const proxyProvided = !!(process.env.UNLEASH_PROXY_URL && process.env.UNLEASH_PROXY_URL.length > 0);
  const proxySecretProvided = !!(process.env.UNLEASH_PROXY_SECRET && process.env.UNLEASH_PROXY_SECRET.length > 0);
  const [proxyHealth, setProxyHealth] = useState<[RequestStatus, string | undefined]>(['Loading', undefined]);

  useEffect(() => {
    setProxyHealth(['Loading', proxyHealth[1]]);
    if (!proxyProvided) {
      setProxyHealth(['Error', 'Proxy URL not provided']);
    } else if (!proxySecretProvided) {
      setProxyHealth(['Error', 'Proxy secret not provided']);
    } else {
      axios.get(
        `${process.env.UNLEASH_PROXY_URL}/health`,
        { headers: { Authorization: `${process.env.UNLEASH_PROXY_SECRET}` } },
      )
        .then(res => {
          const text = res.data;
          if (text === 'ok') setProxyHealth(['Ok', undefined]);
          else setProxyHealth(['Error', text]);
        })
        .catch(res => setProxyHealth(['Error', res.data]));
    }
  }, []);

  return proxyHealth;
};
